import { UsersListContainer } from '@/modules/Users';

const UsersList = (): JSX.Element => <UsersListContainer />;

export default UsersList;
